import React, { FC } from "react";
import styled from "styled-components";
import Route from "./Route";
import Row from "./Row";
import { IRoadmap } from "@/shared/types/roadmap";
import Switcher from "./Switcher";
import useRoadmaps from "../useRoadmapsBSI";
import LoaderCircle from "../../loaders/LoaderCircle";
import RouteNames from "./RouteNames";
import { useSelector } from "react-redux";
import { RootState } from "@/store/redux/store";

interface IParams {
    isTram?: boolean
}

const RouteList: FC<IParams> = ({ isTram }) => {
    const {
        routes,
        initRoutes,
        selectedRouteNames, handleSelectedRouteNames,
        isLowFloorTransportEnabled,
        loading,
    } = useRoadmaps();

    if (loading) return <LoaderContainer>
        <LoaderCircle />
    </LoaderContainer>


    return (
        <Container>
            {initRoutes && initRoutes.length > 1 &&
                <RouteNamesContaine>
                    <RouteNames
                        routes={initRoutes}
                        selectedRouteNames={selectedRouteNames}
                        setSelectedRouteNames={handleSelectedRouteNames}
                        isTram={isTram}
                    />
                </RouteNamesContaine>}
            <Row />
            {routes?.length > 1 ?
                <ContainerRoutes>
                    {/* <Switcher /> */}
                    {routes?.map((route: IRoadmap, index) => (
                        <Route key={route.route_full_name + route.sort_index + index} route={route} isTram={isTram} />
                    ))}
                </ContainerRoutes>
                : <Text>Актуальные расписания на текущую дату отсутствуют</Text>
            }
        </Container>)
}


export default RouteList;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 95%;
     overflow-y: auto;
    `

const ContainerRoutes = styled.div`
    padding: 10px 0 0;
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const LoaderContainer = styled.div`
    display: flex;
    margin-top: 20px;
    `
const RouteNamesContaine = styled.div`
    padding: 25px 10px;
    // border-bottom: 1px solid gray;
    `
const Text = styled.p`
        font-size: 17px;
        font-weight: 500;
        color: rgb(0,0,0);
    `